import { ColumnConfig } from '@/components/table/Table';
import { ServiceHistoryApi, AssetData } from '../models';
import { getAssetDisplayText } from '../../../components';

export const serviceHistoryTableColumns: ColumnConfig[] = [
  {
    label: 'Equipo',
    field: 'asset',
    render: (value: AssetData) => getAssetDisplayText(value)
  },
  {
    label: 'Usuario asignado',
    field: 'assignedUser',
    render: (value: ServiceHistoryApi['assignedUser'], row: ServiceHistoryApi) => 
      row.assignedUser?.fullName || row.asset?.user?.fullName || 'Sin usuario asignado',
  },
  {
    label: 'Fecha de envío',
    field: 'sentAt',
  },
  {
    label: 'Fecha de retorno',
    field: 'returnedAt',
  },
  {
    label: 'Descripción del fallo',
    field: 'faultDescription',
  },
  {
    label: 'Lugar de reparación',
    field: 'supplierName',
    render: (value: string, row: ServiceHistoryApi) => {
      if (row.supplier) {
        return row.supplier.name;
      }
      if (row.supplierId) {
        return `ID: ${row.supplierId}`;
      }
      return value || 'Ocurrio un error al obtener el proveedor';
    },
  },
  {
    label: 'Teléfono',
    field: 'supplierPhone',
    render: (value: string, row: ServiceHistoryApi) => {
      if (row.supplier) {
        return row.supplier.phone;
      }
      return value || 'Sin teléfono';
    },
  },
  {
    label: 'Notas del diagnóstico',
    field: 'diagnosticNotes',
  },
];
